"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
var List = /** @class */ (function () {
    function List() {
    }
    List.rotate = function (list) {
        if (list === void 0) { list = []; }
        return list.slice(1, list.length).concat(list.slice(0, 1));
    };
    List.lockedRotate = function (list, lockedPosition) {
        if (list === void 0) { list = []; }
        if (lockedPosition === void 0) { lockedPosition = 1; }
        list = __spreadArray([], list);
        return __spreadArray(__spreadArray([], list.splice(0, lockedPosition)), this.rotate(list));
    };
    return List;
}());
exports.default = List;
//# sourceMappingURL=list.js.map